import React, {useMemo} from 'react';
import {Form, Input} from 'antd';

interface Props {
    name: string | (string | number)[];
    label: string;
    maxLength: number;
    required?: boolean;
    hidden?: boolean;
    counterOffsetTop?: number;
}

const CharacterCountdownInput: React.FC<Props> = ({
                                                      name,
                                                      label,
                                                      maxLength,
                                                      required = false,
                                                      hidden = false,
                                                      counterOffsetTop = 4
                                                  }) => {
    const form = Form.useFormInstance();
    const value: string = Form.useWatch(name, form) ?? '';
    const remaining = useMemo(() => maxLength - value.length, [maxLength, value]);

    return (
        <Form.Item
            name={name}
            label={label}
            hidden={hidden}
            rules={[
                // { required, message: `Please input ${label.toLowerCase()}` },
                { required, message: '' },
                { max: maxLength, message: `${label} must be less than ${maxLength} characters` }
            ]}
            extra={
                hidden ? null : (
                    <div style={{
                        width: '100%',
                        textAlign: 'right',
                        fontSize: '0.75rem',
                        color: '#999',
                        marginTop: counterOffsetTop
                    }}>
                        {remaining} letters left
                    </div>
                )
            }
        >
            <Input maxLength={maxLength}/>
        </Form.Item>
    );
};

export default CharacterCountdownInput;